// Generated by @speria-jp/json-schema-validator-gen
// https://github.com/speria-jp/json-schema-validator-gen
// Do not edit manually
// ============================================================================
// Validation Types (auto-generated)
// ============================================================================

type ValidationResult<T> =
  | { success: true; data: T }
  | { success: false; issues: ValidationIssue[] };

interface ValidationIssue {
  code: ValidationIssueCode;
  path: (string | number)[];
  message: string;
  expected: string;
  received: string;
}

type ValidationIssueCode =
  | "invalid_type"
  | "invalid_value"
  | "too_small"
  | "too_big"
  | "invalid_string"
  | "not_integer"
  | "not_unique"
  | "unrecognized_key"
  | "missing_key";

interface ValidationOptions {
  abortEarly?: boolean;
}

// ============================================================================
// Validation Helpers (auto-generated)
// ============================================================================

function _getType(value: unknown): string {
  if (value === null) return "null";
  if (Array.isArray(value)) return "array";
  return typeof value;
}

function _invalidType(issues: ValidationIssue[], path: (string | number)[], expected: string, value: unknown): void {
  const received = _getType(value);
  issues.push({ code: "invalid_type", path, message: `Expected ${expected}, received ${received}`, expected, received });
}

function _missingKey(issues: ValidationIssue[], path: (string | number)[], key: string): void {
  const expected = `object with required property "${key}"`;
  const received = `object without property "${key}"`;
  issues.push({ code: "missing_key", path, message: `Expected ${expected}, received ${received}`, expected, received });
}

function _tooSmall(issues: ValidationIssue[], path: (string | number)[], expected: string, received: string): void {
  issues.push({ code: "too_small", path, message: `Expected ${expected}, received ${received}`, expected, received });
}

function _tooBig(issues: ValidationIssue[], path: (string | number)[], expected: string, received: string): void {
  issues.push({ code: "too_big", path, message: `Expected ${expected}, received ${received}`, expected, received });
}

function _invalidString(issues: ValidationIssue[], path: (string | number)[], expected: string, received: string): void {
  issues.push({ code: "invalid_string", path, message: `Expected ${expected}, received ${received}`, expected, received });
}

function _invalidValue(issues: ValidationIssue[], path: (string | number)[], expected: string, received: string): void {
  issues.push({ code: "invalid_value", path, message: `Expected ${expected}, received ${received}`, expected, received });
}

function _notInteger(issues: ValidationIssue[], path: (string | number)[], value: number): void {
  issues.push({ code: "not_integer", path, message: `Expected integer, received ${value}`, expected: "integer", received: String(value) });
}

function _notUnique(issues: ValidationIssue[], path: (string | number)[]): void {
  issues.push({ code: "not_unique", path, message: "Expected array with unique items, received array with duplicate items", expected: "array with unique items", received: "array with duplicate items" });
}

function _unrecognizedKey(issues: ValidationIssue[], path: (string | number)[], expected: string, key: string): void {
  issues.push({ code: "unrecognized_key", path, message: `Expected ${expected}, received ${key}`, expected, received: key });
}


export type KarteSchema = {
    meta: {
        version: "20250521" | "karteSchema/20250521";
    };
    fields: {
        key: string;
        label: string;
        format?: "DateTime" | "Date" | "Time" | "Integer";
        instruction?: string;
    }[];
};


export function validateKarteSchema(value: unknown, options?: ValidationOptions): ValidationResult<KarteSchema> {
    const issues: ValidationIssue[] = [];
    const abortEarly = options?.abortEarly ?? false;
    if (!(typeof value === "object" && value !== null && !Array.isArray(value))) {
        _invalidType(issues, [], "object", value);
        if (abortEarly)
            return { success: false, issues };
    }
    else {
        if (!("meta" in value)) {
            _missingKey(issues, [], "meta");
            if (abortEarly)
                return { success: false, issues };
        }
        if (!("fields" in value)) {
            _missingKey(issues, [], "fields");
            if (abortEarly)
                return { success: false, issues };
        }
        if ("meta" in value) {
            if (!(typeof value.meta === "object" && value.meta !== null && !Array.isArray(value.meta))) {
                _invalidType(issues, ["meta"], "object", value.meta);
                if (abortEarly)
                    return { success: false, issues };
            }
            else {
                if (!("version" in value.meta)) {
                    _missingKey(issues, ["meta"], "version");
                    if (abortEarly)
                        return { success: false, issues };
                }
                if ("version" in value.meta) {
                    let _anyOfMatched1 = false;
                    if (!_anyOfMatched1 && (() => {
                        const _tempIssues: ValidationIssue[] = [];
                        if (value.meta.version !== "20250521") {
                            _invalidValue(_tempIssues, ["meta", "version"], "\"20250521\"", JSON.stringify(value.meta.version));
                            if (abortEarly)
                                return { success: false, _tempIssues };
                        }
                        return _tempIssues.length === 0;
                    })()) {
                        _anyOfMatched1 = true;
                    }
                    if (!_anyOfMatched1 && (() => {
                        const _tempIssues: ValidationIssue[] = [];
                        if (value.meta.version !== "karteSchema/20250521") {
                            _invalidValue(_tempIssues, ["meta", "version"], "\"karteSchema/20250521\"", JSON.stringify(value.meta.version));
                            if (abortEarly)
                                return { success: false, _tempIssues };
                        }
                        return _tempIssues.length === 0;
                    })()) {
                        _anyOfMatched1 = true;
                    }
                    if (!_anyOfMatched1) {
                        issues.push({ code: "invalid_type", path: ["meta", "version"], message: `Expected ${"value matching at least one schema"}, received ${"value matching no schemas"}`, expected: "value matching at least one schema", received: "value matching no schemas" });
                        if (abortEarly)
                            return { success: false, issues };
                    }
                }
                for (const key2 in value.meta) {
                    if (!["version"].includes(key2)) {
                        _unrecognizedKey(issues, ["meta", key2], `one of known properties (${["version"].join(", ")})`, key2);
                        if (abortEarly)
                            return { success: false, issues };
                    }
                }
            }
        }
        if ("fields" in value) {
            if (!Array.isArray(value.fields)) {
                _invalidType(issues, ["fields"], "array", value.fields);
                if (abortEarly)
                    return { success: false, issues };
            }
            else {
                for (let i3 = 0; i3 < value.fields.length; i3++) {
                    if (!(typeof value.fields[i3] === "object" && value.fields[i3] !== null && !Array.isArray(value.fields[i3]))) {
                        _invalidType(issues, ["fields", i3], "object", value.fields[i3]);
                        if (abortEarly)
                            return { success: false, issues };
                    }
                    else {
                        if (!("key" in value.fields[i3])) {
                            _missingKey(issues, ["fields", i3], "key");
                            if (abortEarly)
                                return { success: false, issues };
                        }
                        if (!("label" in value.fields[i3])) {
                            _missingKey(issues, ["fields", i3], "label");
                            if (abortEarly)
                                return { success: false, issues };
                        }
                        if ("key" in value.fields[i3]) {
                            if (!(typeof value.fields[i3].key === "string")) {
                                _invalidType(issues, ["fields", i3, "key"], "string", value.fields[i3].key);
                                if (abortEarly)
                                    return { success: false, issues };
                            }
                        }
                        if ("label" in value.fields[i3]) {
                            if (!(typeof value.fields[i3].label === "string")) {
                                _invalidType(issues, ["fields", i3, "label"], "string", value.fields[i3].label);
                                if (abortEarly)
                                    return { success: false, issues };
                            }
                        }
                        if ("format" in value.fields[i3]) {
                            if (!(["DateTime", "Date", "Time", "Integer"] as unknown[]).includes(value.fields[i3].format)) {
                                _invalidValue(issues, ["fields", i3, "format"], "\"DateTime\" | \"Date\" | \"Time\" | \"Integer\"", JSON.stringify(value.fields[i3].format));
                                if (abortEarly)
                                    return { success: false, issues };
                            }
                        }
                        if ("instruction" in value.fields[i3]) {
                            if (!(typeof value.fields[i3].instruction === "string")) {
                                _invalidType(issues, ["fields", i3, "instruction"], "string", value.fields[i3].instruction);
                                if (abortEarly)
                                    return { success: false, issues };
                            }
                            else {
                                if (value.fields[i3].instruction.length > 200) {
                                    _tooBig(issues, ["fields", i3, "instruction"], "string with length <= 200", `string with length ${value.fields[i3].instruction.length}`);
                                    if (abortEarly)
                                        return { success: false, issues };
                                }
                            }
                        }
                        for (const key4 in value.fields[i3]) {
                            if (!["key", "label", "format", "instruction"].includes(key4)) {
                                _unrecognizedKey(issues, ["fields", i3, key4], `one of known properties (${["key", "label", "format", "instruction"].join(", ")})`, key4);
                                if (abortEarly)
                                    return { success: false, issues };
                            }
                        }
                    }
                }
            }
        }
        for (const key5 in value) {
            if (!["meta", "fields"].includes(key5)) {
                _unrecognizedKey(issues, [key5], `one of known properties (${["meta", "fields"].join(", ")})`, key5);
                if (abortEarly)
                    return { success: false, issues };
            }
        }
    }
    if (issues.length > 0) {
        return { success: false, issues };
    }
    return { success: true, data: value as KarteSchema };
}
export function unsafeValidateKarteSchema(value: unknown): KarteSchema {
    const result = validateKarteSchema(value, { abortEarly: true });
    if (!result.success) {
        throw new Error("Validation failed: value is not KarteSchema");
    }
    return result.data;
}
